module.exports = __webpack_public_path__ + "static/fighter-cutout-7d9c48c2d1c848eef49b940448f986dc.png";